import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sparkles, ChevronLeft } from 'lucide-react';
import { Stack } from '@easymoving/ui';
import type { SmartPrompt } from '../../lib/query/smartPrompts';

/** Dashboard nudges (PRD §10.6). Renders nothing when there's nothing to nudge. */
export function SmartPrompts({ prompts }: { prompts: SmartPrompt[] }) {
  const { t } = useTranslation();
  if (prompts.length === 0) return null;
  return (
    <Stack gap="xs">
      {prompts.map((p) => (
        <Link
          key={p.key}
          to={p.to}
          className="surface px-4 py-3 flex items-center justify-between gap-3 hover:bg-surface-tint transition-colors"
        >
          <span className="text-[14px] flex items-center gap-2">
            <Sparkles className="size-4 text-amber shrink-0" />
            {t(`smartPrompt.${p.key}`, { count: p.count })}
          </span>
          <ChevronLeft className="size-4 text-graphite-soft shrink-0" />
        </Link>
      ))}
    </Stack>
  );
}
